import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetCivilContests } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { civilContestsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfCivilContestContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const civilContests = useAppSelector(civilContestsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().civilContests });

  const hasData = civilContests.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(civilContests, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Конкурсы, соревнования" Icon={IconWidgetCivilContests}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfCivilContestContainer;
